import React, { useContext } from 'react';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import { useHistory } from 'react-router-dom';
import { AppContext, IAppContext } from 'appState/appContext';
import {
	ChangeCategoryPositionContext,
	IChangeCategoryPositionContext,
} from '../../../changeCategoryPositionState/changeCategoryPositionContext';
import { updateCategoryPositions } from 'backend/categories';
import Text from 'components/Text/Text';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		typeOfModalWindow,
		positionsData,
		selectedRestaurant,
		selectedAdditionalRestaurants,
	} = useContext<IChangeCategoryPositionContext>(ChangeCategoryPositionContext);
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const history = useHistory();
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const restaurantsToApplyChanges = selectedRestaurant ? [selectedRestaurant, ...selectedAdditionalRestaurants] : [];

	const handleRedirect = () => {
		history.push('/menu/category');
	};

	const handleConfirm = async () => {
		if (positionsData && selectedRestaurant) {
			try {
				const restaurantIds = [selectedRestaurant.id, ...selectedAdditionalRestaurants.map((el) => el.id)];
				const categoryIds = positionsData.map((el) => el.id);
				showLoader();
				await updateCategoryPositions({
					restaurantIds,
					categoryIds,
				});
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	};

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={handleRedirect}
				onFailureEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'toConfirmFieldsClearing'}
				description="cancelSaveInfo"
			/>
			<ModalToConfirm
				onConsentEvent={handleConfirm}
				onFailureEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'toConfirmSave'}
				description="saveInfo"
				typeOfInfoIcon="withoutIcon"
				additionalContent={
					!!restaurantsToApplyChanges?.length && (
						<div className={style.itemsList}>
							{restaurantsToApplyChanges.map((el) => (
								<Text
									key={el.id}
									translationKey={el.name}
									theme="secondaryLight"
									size="l"
									weight="bold"
								/>
							))}
						</div>
					)
				}
			/>
			<ModalSentSuccessfully
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
		</div>
	);
};

export default ModalWindows;
